import { useEffect, useState } from "react";
import { getPrincipalMessage } from "../Service/Api";
import Breadcrumb from "../Component/Breadcrumb";
import LazyLoad from "react-lazyload";
const removeHtmlTags = (str) => {
  return str.replace(/<[^>]*>/g, ""); // Removes anything between '<' and '>'
};
const Headboy = () => {
  const [data, setData] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      const messages = await getPrincipalMessage();
      setData(messages);
    };
    fetchData();
  }, []);
  const emptyArray = [
    // { description: "“Educating the mind without educating the heart is no education at all.” Sacred Heart has been educating boys and girls since 1990; though much has changed over the years our mission remains the same. Sacred Heart is committed to developing students of high academic achievement, intellectual curiosity, and strong moral character. As a result, year after year Sacred Heart sends our respectful, responsible and compassionate young adults, who are well prepared to tackle the challenges that lay ahead. Since arriving at Sacred Heart in 2016, I have had the opportunity to observe this unique institution up close. I have seen its commitment to academic excellence, its dynamic student body, and incredibly committed faculty and a loving community where the students and families are proud and supportive of one another. As I walk down the hallways of the school every day, I can hear the chatter of eager minds; the shouts of excitement from the victorious athletes, the thumb of dancers feed and the sound of melodious voices harmonizing the perpetual energy, movement and enthusiasm permeate the atmosphere. Ours is a school with difference. We value creativity and innovation and strive to nurture them in our students. Sacred Heartians are groomed to become confident, articulate and enlightened young citizens ready to step into the global society with dignity, honour and integrity. Aristotle once said “Educating the mind without educating the heart is no education at all”. Even as we impart education to match the advancement in technology and globalization, we march our children ahead with Sacred Heart ethos of moral values and principles. We Endeavour constantly to instill these qualities in our children. We pride ourselves to help them grow and develop into sensitive, responsible God loving citizens of the future. May the Sacred Heart of Jesus bless us abundantly in all our endeavourers.", attachments: "director.jpg" },
  ];
  return (
    <>
      <Breadcrumb
        breadtitle="Head Boy's Message"
        breadmid="About"
        breadend="Head Boy's Message"
      />
      <div className="innerpage">
        <div className="container">
          {data?.length > 0 ? (
            data
              ?.filter((div) => div.category === "HeadBoy")
              .map((item, index) => (
                <div className="row message_inner" key={index}>
                  <div className="col-lg-4 col-md-4">
                    <LazyLoad>
                      <img
                        src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.attachments}`}
                        className="inner_img img-fluid"
                        alt="Cannosa School, Lucknow"
                      />
                    </LazyLoad>
                  </div>
                  <div className="col-lg-8 col-md-8 messagebox">
                    <p>{removeHtmlTags(item.message)}</p>
                    <h5 className="mb-0">{item.name} </h5>
                    <h5>
                      <span> {item.category} </span>
                    </h5>
                    <div className="clr"></div>
                  </div>
                </div>
              ))
          ) : (
            <div className="row message_inner">
              <div className="col-lg-4 col-md-4">
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/headboy.png"
                    className="inner_img img-fluid"
                    alt="Canossa School, Lucknow"
                  />
                </LazyLoad>
              </div>
              <div className="col-lg-8 col-md-8 messagebox">
                <p>Dear school community,</p>
                <p>
                  Being the head boy of an institution as prestigious as this,
                  in itself is an honour for me.
                </p>
                <p>
                  I would call myself blessed if I get to serve this school even
                  a bit and give my contribution into the betterment of the
                  institution
                </p>

                <p>
                  The management here, is the most dignified as well as equally
                  understanding, our honourable principal sister or our
                  respected vice principal sister never fails to make us feel u
                  understood and heard.
                </p>
                <p>
                  The teachers, the backbone of the school are constantly
                  putting efforts for the making of our future, they go out of
                  the way to impart knowledge in us.
                </p>
                <p>
                  The children here, my batch mates and every other canossian
                  makes the atmosphere so warm and personal that one can never
                  feel parted from the school, being the senior most in the
                  school, I recall my journey of growing up and learning things
                  in this school and with my whole heart I thank the school for
                  all the values it gave me.
                </p>
                <br />
                <p>With sincere regards</p>
                <h5 className="mb-0">Nikhil Yadav </h5>
                <h5>
                  <span>Head Boy</span>
                </h5>
                <div className="clr"></div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Headboy;
